/* eslint-disable max-lines */
import { PageId } from 'root-constants/pages'

export const enum CurrentEnvironment {
  DEV = 'dev',
  PROD = 'prod',
  STAGE = 'stage',
}

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
}

export const enum CardPaymentFieldName {
  NAME = 'name',
  NUMBER = 'cardNumber',
  EXPIRY = 'cardExpiry',
  CVC = 'cardCvc',
}

export const enum SubscriptionListType {
  PURCHASE = 'purchase',
  UPGRADE = 'upgrade',
  UPSELL = 'upsell',
}

export const enum SubscriptionTag {
  TAX = 'tax',
  TAX_US = 'tax_us',
  TAX_US_FULL_OFFER = 'tax_us_full_offer',
  NO_TAX = 'no_tax',
  NO_TAX_ES = 'no_tax_es',
  CANCEL_OFFER = 'cancel',
  NO_TAX_UPSELL = 'no_tax_upsell',
  TAX_UPSELL = 'tax_upsell',
}

export const BASE_COLUMN_WIDTH = 311

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  DEFAULT_PHONE = 375,
  MAX_PHONE = 441,
  TABLET = 768,
  LAPTOP = 1200,
}

export const HEADER_HEIGHT = 56
export const FAMY_LOCATE_HEADER_HEIGHT = 53
export const STORE_ONE_LINK =
  'https://famio.onelink.me/b9Ag?af_xp=custom&pid=web2web_payment_success'

export const CONTACT_FORM_LINKS = {
  [CurrentEnvironment.DEV]: 'https://account-famio.gidev.xyz/contact-form',
  [CurrentEnvironment.PROD]: 'https://account.myfamio.com/contact-form',
  [CurrentEnvironment.STAGE]: 'https://account-famio.gistage.com/contact-form',
}

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const AWS_SHORTENER_API_KEY = 'JdEX69pWneoo0DRz8wg49gkyTnKttEHa5xEfTtOc'

export const enum LoginMethod {
  EMAIL = 'email',
}

export const enum ProductKey {
  ONE_WEEK = 'oneWeek',
  ONE_MONTH = 'oneMonth',
  THREE_MONTHS = 'threeMonths',
  UPSELL_BUNDLE = 'upsellBundle',
  PATH_TO_USER = 'pathToUser',
  DRIVING_MODE = 'drivingMode',
}

export const enum FirebaseSignUpErrorCode {
  EMAIL_EXISTS = 'auth/email-already-in-use',
}

export const enum Color {
  DEFAULT_TEXT = '#0a324d',
  LIGHT_TEXT = '#7b8898',
  ERROR = '#fe5959',
  RED = '#fc5774',
  GREY = '#eff5f7',
  LIGHT_GREY = '#f0f2fa',
  ACCENT_VIOLET = '#6336ff',
  WHITE = '#fff',
  BLUE = '#5c90ff',
  LIGHT_BLUE = '#91bfff',
  DEEP_BLUE = '#3e3baf',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export const enum BillingCycle {
  ONE_MONTH = 1,
  THREE_MONTHS = 3,
  SIX_MONTHS = 6,
  NINE_MONTHS = 9,
  YEAR = 12,
}

export const enum TrialPeriod {
  ONE_DAY = 1,
  TWO_DAYS = 2,
  THREE_DAYS = 3,
  FOUR_DAYS = 4,
  ONE_WEEK = 7,
  ONE_MONTH = 30,
  THREE_MONTH = 90,
  SIX_MONTH = 180,
  ONE_YEAR = 360,
}

export const TRIAL_IN_HOURS = {
  [TrialPeriod.ONE_DAY]: 24,
  [TrialPeriod.TWO_DAYS]: 48,
  [TrialPeriod.THREE_DAYS]: 72,
  [TrialPeriod.FOUR_DAYS]: 96,
}

export const enum Currency {
  USD = 'usd',
  EUR = 'eur',
  AUD = 'aud',
  CAD = 'cad',
  GBP = 'gbp',
  MXN = 'mxn',
  NZD = 'nzd',
  BRL = 'brl',
  TRY = 'try',
  JPY = 'jpy',
  INR = 'inr',
}

export const CURRENCY_SYMBOLS = {
  [Currency.USD]: '$',
  [Currency.EUR]: '€',
  [Currency.AUD]: 'AU$',
  [Currency.CAD]: 'C$',
  [Currency.GBP]: '£',
  [Currency.MXN]: 'MXN',
  [Currency.NZD]: 'NZ$',
  [Currency.BRL]: 'R$',
  [Currency.TRY]: '₺',
  [Currency.JPY]: '¥',
  [Currency.INR]: '₹',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum Cohort {
  MAIN_9 = 'famio_main9',
  MAIN_SAFETY = 'famio_main_safety',
  MAIN_SAFETY_V2 = 'famio_main_safety_v2',
  MAIN_SAFETY_V3 = 'famio_main_safety_v3',
  MAIN_SAFETY_V4 = 'famio_main_safety_v4',
  MAIN_SAFETY_MAP = 'famio_main_safety_map',
  MAIN_SAFETY2_APPL = 'famio_safety2_appl',
  SAFETY_2 = 'famio_safety2',
  GOOGLE_1 = 'famio_google_1',
  GOOGLE_2 = 'famio_google_2',
  GOOGLE_3 = 'famio_google_3',
  GOOGLE_4 = 'famio_google_4',
  GOOGLE_5 = 'famio_google_5',
  GOOGLE_6 = 'famio_google_6',
  GOOGLE_7 = 'famio_google_7',
  GOOGLE_9 = 'famio_google_9',
  GOOGLE_13 = 'famio_google_13',
  GOOGLE_18 = 'famio_google_18',
  GOOGLE_MAIN_10 = 'famio_google_main10',
  GOOGLE_CHECKOUT = 'famio_google_checkout',
  FAMYLOCATE_V1 = 'famylocate_v1',
  FAMYLOCATE_V1_UPI = 'famylocate_v1_upi',
  FAMYLOCATE_V1_PIX = 'famylocate_v1_pix',
}

export const DESKTOP_COHORTS: string[] = [
  Cohort.GOOGLE_9,
  Cohort.FAMYLOCATE_V1,
  Cohort.GOOGLE_7,
]

export const TRIAL_COHORTS: string[] = [Cohort.SAFETY_2]

export const COHORTS_WITH_USA_FLOW: string[] = [
  Cohort.MAIN_9,
  Cohort.MAIN_SAFETY,
  Cohort.MAIN_SAFETY_MAP,
]

export const COHORTS_WITHOUT_USA_FLOW: string[] = [
  Cohort.GOOGLE_9,
  Cohort.FAMYLOCATE_V1,
]

export const FAMYLOCATE_COHORTS: string[] = [
  Cohort.FAMYLOCATE_V1,
  Cohort.FAMYLOCATE_V1_PIX,
  Cohort.FAMYLOCATE_V1_UPI,
]

export const PUBLIC_PAGES: PageId[] = [
  PageId.SUBSCRIPTIONS_GOOGLE_1,
  PageId.SUBSCRIPTIONS_GOOGLE_2,
  PageId.SUBSCRIPTIONS_GOOGLE_4,
  PageId.BLACK_FRIDAY_OFFER_1,
]
export const POST_PAYMENT_PAGES: PageId[] = [PageId.ACCOUNT, PageId.DOWNLOAD]

export const TEST_ENV_QUERY_PARAM = 'is_test_environment'

export const APP_NAME = 'famio'
export const CENTS_IN_DOLLAR = 100
export const INITIAL_PRICE = 0
export const DEFAULT_CURRENCY = Currency.USD
export const NO_NAME_AB_SEGMENT = 'no_name'
export const NO_GROWTH_BOOK_TEST = 'no_test'
export const EXPERIMENT_ID_NOT_SET = 'experiment_id_not_set'
export const FAMYLOCATE_ROOT_DOMAIN = 'famylocate'
export const SAFE_FAMILY_ROOT_DOMAIN = 'safefamily'

export const SINGLE_GOAL_LENGTH = 1

export const enum Frequency {
  QUITE_OFTEN = 'quite_often',
  SOMETIMES = 'sometimes',
  RARELY = 'rarely',
  NEVER = 'never',
  NOT_SURE = 'not_sure',
  OFTEN = 'often',
  ALWAYS = 'always',
}

export const enum Confidence {
  YES = 'yes',
  NO = 'no',
  NOT_SURE = 'not_sure',
  SOMETIMES = 'sometimes',
  CANT_REMEMBER = 'cant_remember',
}

export const enum TrackingData {
  BATTERY_ALERTS = 'battery_alerts',
  SOS_NOTIFICATIONS = 'sos_messages',
  DRIVING_MODE = 'car_crash_notifications',
  GET_HURTS = 'somebody_get_hurts',
}

export const enum ChildAgeRange {
  BABY = '0-5',
  KID = '6-11',
  TEENAGER = '12-18',
  ADULT = '18+',
}

export const Gender = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
}

export const enum UserGoal {
  PARTNER = 'partner',
  KID = 'kid',
  FRIEND = 'friend',
  OTHER = 'other',
  TEEN = 'teen',
}

export const enum CountryCode {
  UNITED_STATES = 'us',
  ARGENTINA = 'ar',
  COLOMBIA = 'co',
  PERU = 'pe',
  CHILE = 'cl',
  DOMINICAN_REPUBLIC = 'do',
  URUGUAY = 'uy',
  ECUADOR = 'ec',
  GUATEMALA = 'gt',
  VENEZUELA = 've',
  PARAGUAY = 'py',
  BOLIVIA = 'bo',
  NICARAGUA = 'ni',
  HONDURAS = 'hn',
  COSTA_RICA = 'cr',
  PANAMA = 'pa',
  EL_SALVADOR = 'sv',
  MEXICO = 'mx',
  PUERTO_RICO = 'pr',
  BRAZIL = 'br',
  INDIA = 'in',
  PHILIPPINES = 'ph',
  SOUTH_AFRICA = 'za',
  NIGERIA = 'ng',
  KENYA = 'ke',
  ZAMBIA = 'zm',
  TANZANIA = 'tz',
  ETHIOPIA = 'et',
  ZIMBABWE = 'zw',
  SENEGAL = 'sn',
  NAMIBIA = 'na',
  SAUDI_ARABIA = 'sa',
  TURKEY = 'tr',
  KUWAIT = 'kw',
  IRAQ = 'iq',
  UNITED_ARAB_EMIRATES = 'ae',
  JORDAN = 'jo',
  QATAR = 'qa',
  LEBANON = 'lb',
  OMAN = 'om',
  BAHRAIN = 'bh',
  EGYPT = 'eg',
  MOROCCO = 'ma',
  ALGERIA = 'dz',
  POLAND = 'pl',
}

export const PERIOD_NAME_TO_MARKUP_MAP = {
  week: 'subscriptions.planBlock.planPeriods.week',
  month: 'subscriptions.planBlock.planPeriods.month',
  day: 'subscriptions.planBlock.planPeriods.day',
}

export const INTRO_OFFER_PERIODS = {
  [TrialPeriod.ONE_WEEK]: 7,
  [TrialPeriod.ONE_MONTH]: 1,
  [TrialPeriod.THREE_MONTH]: 3,
}

export const INTRO_OFFER_PERIOD_NAMES = {
  [TrialPeriod.ONE_WEEK]: 'subscriptions.planBlock.planPeriods.day',
  [TrialPeriod.ONE_MONTH]: 'subscriptions.planBlock.planPeriods.month',
  [TrialPeriod.THREE_MONTH]: 'subscriptions.planBlock.planPeriods.month',
}

export const INTRO_OFFER_WEEKLY_PERIOD_NAMES = {
  [TrialPeriod.ONE_WEEK]: 'subscriptions.planBlock.weeklyPlanPeriods.oneWeek',
  [TrialPeriod.ONE_MONTH]:
    'subscriptions.planBlock.weeklyPlanPeriods.moreThanOneWeek',
  [TrialPeriod.THREE_MONTH]:
    'subscriptions.planBlock.weeklyPlanPeriods.moreThanOneWeek',
}

export const INTRO_OFFER_FULL_PERIOD_NAMES = {
  [TrialPeriod.ONE_DAY]: 'subscriptions.introOfferPeriod.oneDay',
  [TrialPeriod.THREE_DAYS]: 'subscriptions.introOfferPeriod.threeDay',
  [TrialPeriod.ONE_WEEK]: 'subscriptions.introOfferPeriod.week',
  [TrialPeriod.ONE_MONTH]: 'subscriptions.introOfferPeriod.oneMonth',
  [TrialPeriod.THREE_MONTH]: 'subscriptions.introOfferPeriod.threeMonth',
  [TrialPeriod.SIX_MONTH]: 'subscriptions.introOfferPeriod.sixMonth',
}

export const TRIAL_PERIODICITY_TO_MARKUP_MAP = {
  [TrialPeriod.ONE_DAY]: 'subscriptions.description.monthly',
  [TrialPeriod.THREE_DAYS]: 'subscriptions.description.monthly',
  [TrialPeriod.ONE_WEEK]: 'subscriptions.description.monthly',
  [TrialPeriod.ONE_MONTH]: 'subscriptions.description.monthly',
  [TrialPeriod.THREE_MONTH]: 'subscriptions.description.quarterly',
  [TrialPeriod.SIX_MONTH]: 'subscriptions.description.semiAnnually',
}

export const enum Language {
  ES = 'es',
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  PT = 'pt',
  IT = 'it',
  ZH = 'zh',
  AR = 'ar',
  JA = 'ja',
  KO = 'ko',
  TR = 'tr',
  IN_CONTEXT = 'af',
}

export const LANG_QUERY_PARAM = 'lang'
export const INITIAL_LANGUAGE = Language.EN
export const SUPPORTED_LOCALES: string[] = [
  Language.EN,
  Language.ES,
  Language.DE,
  Language.FR,
  Language.PT,
  Language.IT,
  Language.ZH,
  Language.AR,
  Language.JA,
  Language.KO,
  Language.TR,
]

export const DYNAMIC_PAGE_ID_PREFIX = 'dynamic'

export const CDN_FOLDER_LINK =
  'https://cdn-prod-unified-content.gismart.xyz/d07f41c2d723bc846a1e179da43ae3c95cbdbb81345281bc599ad3d1618ca197'

export const enum PlanAddition {
  PREMIUM = 'Premium',
  UPGRADE = 'Upgrade',
  UPSELL = 'Upsell',
}

export const PLAN_ADDITIONS_MAP: Record<string, PlanAddition[]> = {
  [PageId.UPSELL_2]: [PlanAddition.UPSELL],
  [PageId.UPSELL_3]: [PlanAddition.UPSELL],
}

export const VAT_INCLUDED_COUNTRIES: string[] = [CountryCode.UNITED_STATES]
export const VAT_INCLUDED_COHORTS: string[] = [
  Cohort.SAFETY_2,
  Cohort.MAIN_SAFETY_V2,
  Cohort.MAIN_SAFETY_V3,
  Cohort.FAMYLOCATE_V1,
  Cohort.GOOGLE_1,
  Cohort.GOOGLE_2,
  Cohort.GOOGLE_3,
  Cohort.GOOGLE_4,
  Cohort.GOOGLE_5,
  Cohort.GOOGLE_6,
  Cohort.GOOGLE_7,
  Cohort.GOOGLE_9,
  Cohort.GOOGLE_13,
  Cohort.GOOGLE_18,
  Cohort.GOOGLE_MAIN_10,
  Cohort.GOOGLE_CHECKOUT,
]
export const EMPTY_OLD_PRICE = {
  fullPrice: 0,
  amountOfDiscount: 0,
  weekly: 0,
  daily: 0,
  monthly: 0,
  yearly: 0,
  percentOfDiscount: 0,
}

export const enum CheckboxCustomValue {
  ALL_OF_THE_ABOVE = 'all_of_the_above',
}

export const CHECKBOX_CUSTOM_VALUES: string[] = [
  CheckboxCustomValue.ALL_OF_THE_ABOVE,
]

export const enum Images {
  HUSBAND_CALL = '/images/subscription-husband-call',
  HUSBAND_CALL_LAPTOP = '/images/subscription-husband-call-laptop',
  WIFE_CALL = '/images/subscription-wife-call',
  WIFE_CALL_LAPTOP = '/images/subscription-wife-call-laptop',
  GUARANTEE = '/images/guarantee',
  GOOGLE_SUBS_PHONE = '/images/google-subs-phone',
  GOOGLE_SUBS_PHONE_USA = '/images/google-subs-phone-usa',
  GOOGLE_SUBS_PHONE_PREMIUM = '/images/google-phone-premium',
  GOOGLE_SUBS_PHONE_FAMILY = '/images/google-phone-family',
  GOOGLE_SUBS_DISCOUNT_BADGE = '/images/google-discount-badge',
  GOOGLE_SUBS_PHONE_LOCATION = '/images/google-subs-phone-location',
  GOOGLE_SUBS_PHONE_DESKTOP = '/images/google-subs-phone-desktop',
  LOCATION_LOVED = '/images/location-loved',
  LOCATION_HISTORY = '/images/location-history',
  UNLIMITED_GROUPS = '/images/unlimited-groups',
  SOS_NOTIFICATION = '/images/sos-notification',
  PRIVATE_CHAT = '/images/private-chat',
  UNLIMITED_OFFER_BADGE = '/images/unlimited-offer-badge',
  GOOGLE_PHONE_KID = '/images/google-phone-kid',
  GOOGLE_PHONE_1 = '/images/google-phone-1',
  GOOGLE_PHONE_2 = '/images/google-phone-2',
  GOOGLE_PHONE_3 = '/images/google-phone-3',
  REAL_TIME_LOCATION = '/images/real-time-location',
  LOCATION_HISTORY_ROUNDED = '/images/location-history-rounded',
  PLACE_ALERTS = '/images/place-alerts',
  AR_SEARCH = '/images/ar-search',
  SOS_BUTTON = '/images/sos-button',
  FALL_DETECTION = '/images/fall-detection',
  CRASH_SPEED_CONTROL = '/images/crash-control',
  WEARABLES = '/images/wearables',
  COMPATIBLE_WITH = '/images/compatible-with',
  TRACK_LOCATION = '/images/track-location',
  TRACK_LOCATION_FOCUSED = '/images/track-location-focused',
  REAL_TIME_LOCATION_WITHOUT_BG = '/images/real-time-location-without-bg',
  UNLIMITED_GROUPS_WITHOUT_BG = '/images/unlimited-groups-without-bg',
  UNLIMITED_GROUPS_WITHOUT_BG_FOCUSED = '/images/unlimited-groups-without-bg-focused',
  SOS_NOTIFICATION_WITHOUT_BG = '/images/sos-notification-without-bg',
  SOS_NOTIFICATION_WITHOUT_BG_FOCUSED = '/images/sos-notification-without-bg-focused',
  PRIVATE_CHAT_WITHOUT_BG = '/images/private-chat-without-bg',
  STEPS = '/images/steps',
  STEPS_V2 = '/images/steps-v2',
  TRUSTPILOT_PHONE_DESKTOP = '/images/trustpilot-phone-desktop',
  TRUSTPILOT_PHONE_FOCUSED_DESKTOP = '/images/trustpilot-phone-focused-desktop',
  TRUSTPILOT_PHONE_FOCUSED = '/images/trustpilot-phone-focused',
  SEARCH_NUMBER_PHONE_USA = '/images/search-number-phone-usa',
  BATTERY_ALERTS = '/images/battery-alerts',
}

export const enum AppLinks {
  TOU_LINK = `/${PageId.TERMS_OF_USE}`,
  PP_LINK = `/${PageId.PRIVACY_POLICY}`,
  COOKIE_LINK = `/${PageId.COOKIE_POLICY}`,
}

export const TOU_PP_COOKIE_LINKS: string[] = [
  AppLinks.TOU_LINK,
  AppLinks.PP_LINK,
  AppLinks.COOKIE_LINK,
]

export const enum CookieConsentOption {
  STRICTLY_NECESSARY = 'necessary',
  ANALYTICS_AND_PERFORMANCE = 'analytics',
  ADVERTISING_AND_TARGETING = 'advertising',
  FUNCTIONAL_COOKIES = 'functional_cookies',
  REJECT_ALL = 'reject_all',
}

export const enum GAConsent {
  GRANTED = 'granted',
  DENIED = 'denied',
}

export const enum FBConsent {
  REVOKE = 'revoke',
  GRANT = 'grant',
}

export const enum HotJarClientId {
  PROD = '4995498',
  DEV = '4995500',
}

export const DEFAULT_DYNAMIC_DISCOUNT_AMOUNT = 50
export const DYNAMIC_DISCOUNT_THEME = {
  red: 'linear-gradient(87deg, #C40202 -4.33%, #FF5659 111.17%)',
  blue: 'linear-gradient(87deg, #7B00FF -3.7%, #1BE4FF 119.47%)',
  orange: 'linear-gradient(88deg, #FF0031 -0.53%, #FFBE1B 108.08%)',
}
export const DYNAMIC_DISCOUNT_TITLE_COLORS = {
  red: '#E74C3C',
  blue: '#0091FF',
  orange: '#F83B00',
}
export const DEFAULT_HEADER_BORDER = '1px solid #ccdce5'

export const PIX_TEST_SEGMENTS = {
  A_SEGMENT: 'abtest_wspf_60_a_default',
  B_SEGMENT: 'abtest_wspf_60_b_pix',
}

export const UPI_TEST_SEGMENTS = {
  A_SEGMENT: 'abtest_wspf_97_a_default',
  B_SEGMENT: 'abtest_wspf_97_b_upi',
}

export const COOKIE_CONSENT_LANGUAGES: string[] = [
  Language.EN,
  Language.ES,
  Language.DE,
  Language.FR,
  Language.PT,
  Language.IT,
  Language.AR,
  Language.TR,
]

export const GROWTH_BOOK_FEATURE_KEYS = {
  car_266_phone_number_test: 'car_266_phone_number_test',
  car_1107_link: 'abtest_car_1107_link',
  car_1134_primer_card: 'abtest_car_1134_primer_card',
  car_1813_discounting_ga: 'abtest_car_1813_discounting_ga',
  car_1864_br_pix: 'abtest_car_1864_br_pix',
  car_1933_presale_fb: 'abtest_car_1933_presale_fb',
  car_2012_checkout_discount: 'abtest_car_2012_checkout_discount',
  car_2038_upsell_billing: 'abtest_car_2038_upsell_billing',
  car_2144_first_page_br: 'abtest_car_2144_first_page_br',
  car_2146_features_checkout: 'abtest_car_2146_features_checkout',
  car_2160_email_features: 'abtest_car_2160_email_features',
  car_2170_owner_not_notified: 'abtest_car_2170_owner_not_notified',
  car_2240_owner_not_notified_es: 'abtest_car_2240_owner_not_notified_es',
  car_2175_reviews_email: 'abtest_car_2175_reviews_email',
  car_2210_in_upi_test: 'abtest_car_2210_IN_upi_test',
  car_2230_map_checkout_pt: 'abtest_car_2230_map_checkout_pt',
  car_2229_map_checkout_ww_es: 'abtest_car_2229_map_checkout_ww_es',
  car_2231_reviews_email_es_fr: 'abtest_car_2231_reviews_email_es_fr',
  car_2232_reviews_email_pt: 'abtest_car_2232_reviews_email_pt',
  car_2255_afterpay_celebration: 'abtest_car_2255_afterpay_celebration',
  car_2276_animation_4b: 'abtest_car_2276_animation_4b',
  car_2253_es_search_pr: 'abtest_car_2253_ES_search_pr',
}

export const CAR_2146_TEST_SEGMENTS = {
  VARIANT_A: 'abtest_wspf_89_a_default',
  VARIANT_B: 'abtest_wspf_89_b_above',
  VARIANT_C: 'abtest_wspf_89_c_below',
}

export const RETENO_EVENTS = {
  RESEND_INSTRUCTIONS: 'ResendInstructions',
}

export const USA_STATES_WITH_COOKIES = [
  'CA',
  'CT',
  'CO',
  'VA',
  'NV',
  'UT',
  'AZ',
  'DE',
  'IA',
  'IL',
  'FL',
  'ME',
  'MD',
  'MN',
  'MT',
  'NE',
  'NY',
  'OR',
  'SC',
  'TX',
]

export const USAGE_PURPOSE_VALUES = {
  FAMILY: 'family2',
  PARTNER: 'partner2',
  FRIENDS: 'friends2',
  OWN_DEVICE: 'own_device2',
}

export const YEN_CONVERSION_RATE = 100

export const PAGE_TYPE = {
  PRESALE: 'presale',
  SKIPPABLE: 'skippable',
  QUESTION: 'question',
  SUBSCRIPTIONS: 'subscriptions',
  PAYMENT: 'payment',
  UPSELL: 'upsell',
}
export const CALIFORNIAN_STATE_CODE = 'CA'

export const STRIPE_ACCOUNTS_WITH_PIX: string[] = [
  'famio4',
  'famio5',
  'famio6',
  'famio7',
]

export const STRIPE_ACCOUNTS_WITH_UPI: string[] = ['famio6']
